import { laravelAxios } from '../../../../config/axios/laravelAxios';

async function getToken() {
  return laravelAxios.get('crm/get-token');
}

export default getToken;
